import { Link } from "react-router-dom";
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from "framer-motion";
import { useState } from "react";
import { IsotypeLogo } from "./IsotypeLogo";
import { useLang } from "@/i18n/LanguageContext";

// Floating stamp — a small tri-color isotype pinned to the bottom-right.
// Fades in after the user scrolls past the first viewport and links to Contact.
export function FloatingStamp() {
  const { path, t } = useLang();
  const { scrollY } = useScroll();
  const [visible, setVisible] = useState(false);

  useMotionValueEvent(scrollY, "change", (y) => {
    setVisible(y > 400);
  });

  const label = t?.nav?.cta || "Hablemos de tu negocio";

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40"
          data-testid="floating-stamp"
        >
          <Link
            to={path("contact")}
            aria-label={label}
            title={label}
            className="group relative flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-ink shadow-[0_8px_28px_rgba(0,0,0,0.35)] ring-1 ring-paper/10 transition-transform hover:scale-[1.06] active:scale-95"
            data-testid="floating-stamp-link"
          >
            <IsotypeLogo className="h-8 md:h-10" invert />
            <span
              className="pointer-events-none absolute inset-0 rounded-full ring-1 ring-accent/40 opacity-0 group-hover:opacity-100 transition-opacity"
              aria-hidden="true"
            />
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
